import gsap from 'gsap';

// Funzione per controllare se il cursor è in stato di loading
export function isCursorLoading() {
  const ball = document.querySelector('#ball');
  return ball ? ball.classList.contains('loading-cursor') : false;
}

// Funzione per controllare se siamo su una pagina single-cantine
function isSingleCantinaPage() {
  const mainContent = document.querySelector('#main-content');
  return mainContent && mainContent.classList.contains('cantina-single');
}

// Nuova funzione per recuperare l'ID del post corrente dalla pagina single-cantine
function getCurrentPostId() {
  // Presupponiamo che il main-content abbia un attributo data-post-id impostato da PHP
  const mainContent = document.querySelector('#main-content');
  return mainContent && mainContent.dataset && mainContent.dataset.postId ? parseInt(mainContent.dataset.postId, 10) : null;
}

// Funzione per ottenere il colore del border del cursore in base al tipo di pagina e agli ID specifici
export function getCursorBorderColor() {
  if (isSingleCantinaPage()) {
    const postId = getCurrentPostId();
    // Imposta i colori speciali per gli ID 1103 e 3799
    if (postId === 1103) {
      return '#773D19';
    } else if (postId === 3799) {
      return '#773D19';
    }
    return '#9D5024';
  }
  return '#9D5024';
}

function updateCursorColorStyles(color = getCursorBorderColor()) {
  const ball = document.querySelector('#ball');
  const ballLoader = document.querySelector('#ball-loader');

  if (ball) {
    gsap.set(ball, { borderColor: color });
  }

  if (ballLoader) {
    gsap.set(ballLoader, { borderTopColor: color });
  }
}

// Funzione per avviare l'animazione di caricamento del cursor
export function startCursorLoading() {
  const ball = document.querySelector('#ball');
  const ballLoader = document.querySelector('#ball-loader');
  
  if (!ball || !ballLoader) return;
  
  // Se è già in stato di loading, non fare nulla
  if (ball.classList.contains('loading-cursor')) return;
  
  // Ferma eventuali animazioni precedenti
  const borderColor = getCursorBorderColor();
  gsap.killTweensOf(ball);
  gsap.killTweensOf(ballLoader);
  updateCursorColorStyles(borderColor);
  
  // Nascondi il testo del cursore se presente
  const ballTxt = document.querySelector('#ball__txt');
  if (ballTxt) ballTxt.textContent = '';
  
  // Rimuovi tutte le classi esistenti e aggiungi loading-cursor
  ball.classList.remove('with-icon', 'drag-cursor');
  ball.classList.add('loading-cursor');
  
  // Animazione del cerchio principale
  gsap.to(ball, {
    backgroundColor: 'transparent',
    borderColor: getCursorBorderColor(),
    borderWidth: '4px',
    duration: 0.3,
    opacity: 1,
    scale: 0.5,
  });
  
  // Animazione della linea rotante usando ball-loader
  gsap.set(ballLoader, {
    opacity: 1,
    display: 'block',
    rotation: 0,
    clearProps: 'left,top', // Rimuove eventuali proprietà left/top residue
    borderTopColor: borderColor,
  });
  
  // Animazione infinita di rotazione
  gsap.to(ballLoader, {
    rotation: 360,
    duration: 1,
    ease: 'none',
    repeat: -1
  });
}

// Funzione per fermare l'animazione di caricamento del cursor
export function stopCursorLoading() {
  const ball = document.querySelector('#ball');
  const ballLoader = document.querySelector('#ball-loader');
  
  if (!ball || !ballLoader) return;
  
  // Rimuovi la classe loading
  ball.classList.remove('loading-cursor');
  
  // Ferma l'animazione e nascondi il loader
  gsap.killTweensOf(ballLoader);
  gsap.to(ballLoader, {
    opacity: 0,
    duration: 0.3,
    onComplete: () => {
      ballLoader.style.display = 'none';
      // Reset completo delle proprietà del loader
      gsap.set(ballLoader, { clearProps: 'opacity,rotation,left,top,display' });
      updateCursorColorStyles();
    }
  });
  
  // Ripristina lo stato normale del cursor
  gsap.to(ball, {
    backgroundColor: 'transparent',
    borderColor: getCursorBorderColor(),
    borderWidth: '4px',
    duration: 0.3,
    opacity: 1,
    scale: 0.5,
    // Assicurati che non ci siano proprietà residue
    clearProps: 'backgroundColor,borderColor,borderWidth,transform'
  });
}

export function mouseMove() {
  // Controllo per disabilitare il cursore su schermi sotto i 1025px
  function shouldDisableCursor() {
    return window.innerWidth < 1025;
  }

  const magicCursor = document.querySelector('#magic-cursor');
  if (!magicCursor) return;

  // Se siamo su mobile, nascondi il cursore e non inizializzare
  if (shouldDisableCursor()) {
    magicCursor.style.display = 'none';
    return;
  }

  // Mostra il cursore se non è mobile
  magicCursor.style.display = 'block';
  updateCursorColorStyles();

  const mouse = {
    x: 0,
    y: 0,
  };
  const pos = {
    x: 0,
    y: 0,
  };
  const ratio = 0.65;
  let active = true;

  // Funzione per gestire il resize della finestra
  function handleResize() {
    if (shouldDisableCursor()) {
      // Nascondi il cursore su mobile
      magicCursor.style.display = 'none';
      active = false;
    } else {
      // Mostra il cursore su desktop
      magicCursor.style.display = 'block';
      active = true;
      updateCursorColorStyles();
    }
  }

  // Aggiungi listener per il resize
  window.addEventListener('resize', handleResize);

  window.addEventListener('mousemove', (evt) => {
    if (shouldDisableCursor()) return;
    
    magicCursor.classList.add('show');
    mouse.x = evt.clientX;
    mouse.y = evt.clientY;
  });

  gsap.ticker.add(() => {
    if (!active || shouldDisableCursor()) return;

    pos.x += (mouse.x - pos.x) * ratio;
    pos.y += (mouse.y - pos.y) * ratio;

    gsap.to(document.querySelector('#ball'), {
      duration: 0.4,
      x: pos.x,
      y: pos.y,
    });
  });

  window.addEventListener('mouse/move', (evt) => {
    if (shouldDisableCursor()) return;
    
    pos.x = evt.detail.x;
    pos.y = evt.detail.y;

    gsap.to(document.querySelector('#ball'), {
      duration: 0.3,
      x: pos.x,
      y: pos.y,
    });
  });

  window.addEventListener('mouse/stop', () => {
    active = false;
  });

  window.addEventListener('mouse/start', () => {
    if (!shouldDisableCursor()) {
      active = true;
      updateCursorColorStyles();
    }
  });

  // Hover/leave mouse
  const tl = gsap.timeline();

  document.body.addEventListener('mouseenter', (evt) => {
    // Non eseguire nulla su mobile
    if (shouldDisableCursor()) return;
    
    const target = evt.target;
    const ball = document.querySelector('#ball');
    const ballLoader = document.querySelector('#ball-loader');

    // Non cambiare lo stato del cursor se è in modalità loading
    if (ball.classList.contains('loading-cursor')) {
      return;
    }

    if (target.matches('.menu-item a')) {
      target.classList.add('hover');
      document.querySelectorAll('.menu-item a').forEach(el => el.classList.add('hover__opa'));
      document.querySelectorAll('.menu').forEach(el => el.classList.add('hover'));
    }

    if (target.matches('.swiper')) {
      tl
      .clear()
      .to(ball, {
        borderWidth: '2px',
        duration: 0.2,
        scale: 1,
        overwrite: true,
      });

      ball.classList.add('drag-cursor');
    } else if (target.matches('.sticky__wrap')) {
      const bounds = target.closest('.sticky__wrap').querySelector('.sticky__el').getBoundingClientRect();
      const customScale = target.hasAttribute('data-scale') ? parseFloat(target.getAttribute('data-scale')) : 0.7;

      gsap.to(ball, {
        borderColor: target.hasAttribute('data-bord') ? target.getAttribute('data-bord') : getCursorBorderColor(),
        borderWidth: '4px',
        duration: 0.5,
        scale: customScale,
        overwrite: true,
        x: bounds.left + (bounds.width / 2),
        y: bounds.top + (bounds.height / 2),
      });

      window.dispatchEvent(new CustomEvent('mouse/stop'));
    } else if (target.matches('[data-frecc]')) {
      tl
      .clear()
      .to(ball, {
        backgroundColor: getCursorBorderColor(),
        borderColor: getCursorBorderColor(),
        borderWidth: '2px',
        duration: 0.3,
        opacity: 1,
        scale: 1.2,
        overwrite: true,
      })
      .to(ballLoader, {
        borderWidth: '2px',
        duration: 0.2,
        overwrite: true,
      }, '<');

      ball.classList.add('with-icon');
    } else if(target.matches('.cantina-image')){
      window.dispatchEvent(new CustomEvent('mouse/start'));
      const dragText = target.hasAttribute('data-drag-text') 
        ? target.getAttribute('data-drag-text') 
        : 'Scorri';
      tl
      .clear()
      .to(ball, {
        backgroundColor: getCursorBorderColor(),
        borderColor: getCursorBorderColor(),
        borderWidth: '2px',
        duration: 0.3,
        opacity: 1,
        scale: 1.2,
        overwrite: true,
      })
      .to(ballLoader, {
        borderWidth: '2px',
        duration: 0.2,
        overwrite: true,
      }, '<');

      ball.classList.add('with-drag');
      const ballTxt = document.querySelector('#ball__txt');
      if (ballTxt) ballTxt.textContent = dragText;
    } else if (target.closest('.mu-ball__txt')) {
      tl
      .clear()
      .to(ball, {
        backgroundColor: getCursorBorderColor(),
        borderColor: getCursorBorderColor(),
        borderWidth: '2px',
        duration: 0.3,
        opacity: 1,
        scale: 1.2,
        overwrite: true,
      })
      .to(ballLoader, {
        borderWidth: '2px',
        duration: 0.2,
        overwrite: true,
      });

      document.querySelector('#ball__txt').textContent = target.closest('.mu-ball__txt').getAttribute('data-txt');
    } else if (target.closest('.hide-ball')) {
      tl
        .clear()
        .to(ball, {
          borderWidth: '1px',
          duration: 0.2,
          opacity: 0,
          scale: 1,
          overwrite: true,
        });
    } else if (target.closest('mu-follow')) {
      tl
        .clear()
        .to(ball, {
          borderWidth: '6px',
          duration: 0.3,
          opacity: 1,
          scale: 0.7,
          overwrite: true,
        });
    } else if (target.matches('a, .mu-foot__news-sub:not(:disabled)')) {
      tl
      .clear()
      .to(ball, {
        backgroundColor: target.hasAttribute('data-bg') ? target.getAttribute('data-bg') : getCursorBorderColor(),
        borderWidth: '0px',
        duration: 0.2,
        opacity: 0.15,
        scale: 1.3,
        overwrite: true,
      })
      .to(ballLoader, {
        borderWidth: '2px',
        duration: 0.2,
        overwrite: true,
      }, '<');
    }
  }, {
    capture: true,
    passive: true,
  });

  document.body.addEventListener('mouseleave', (evt) => {
    // Non eseguire nulla su mobile
    if (shouldDisableCursor()) return;
    
    const target = evt.target;
    const ball = document.querySelector('#ball');
    const ballLoader = document.querySelector('#ball-loader');

    // Non cambiare lo stato del cursor se è in modalità loading
    if (ball.classList.contains('loading-cursor')) {
      return;
    }

    let hide = false;

    if (target.matches('.menu-item a')) {
      document.querySelectorAll('.menu-item a').forEach(el => {
        el.classList.remove('hover', 'hover__opa');
      });
      document.querySelectorAll('.menu').forEach(el => el.classList.remove('hover'));
    }

    if (target.matches('.sticky__wrap, [data-frecc], .swiper, .cantina-image')) {
      hide = true;
    } else if (target.closest('.mu-ball__txt')) {
      hide = true;
    } else if (target.matches('mu-follow, .hide-ball')) {
      hide = true;
    } else if (target.matches('.mu-foot__news-sub, a')) {
      hide = !target.closest('mu-follow, .hide-ball');
    }

    if (!hide) return;

    tl
      .clear()
      .to(ball, {
        backgroundColor: 'transparent',
        borderColor: getCursorBorderColor(),
        borderWidth: '4px',
        duration: 0.3,
        opacity: 1,
        scale: 0.5,
        overwrite: true,
      })
      .to(ballLoader, {
        borderWidth: '4px',
        duration: 0.2,
        overwrite: true,
      }, '<');

    document.querySelector('#ball__txt').textContent = '';
    ball.classList.remove('with-icon', 'drag-cursor', 'with-drag');

    if (target.matches('.sticky__wrap')) {
      window.dispatchEvent(new CustomEvent('mouse/start'));
    }
  }, {
    capture: true,
    passive: true,
  });
}